// extracted by mini-css-extract-plugin
export default {"double__btn--div":"double-btn_double__btn--div__lA2De","double__btn--first":"double-btn_double__btn--first__yZWTE","double__btn--second":"double-btn_double__btn--second__tZXEv"};